import {BREADCRUMB_FILTER_KEYS} from "./types";
import {SelectedFilter} from "@/entities/catalog";
import {BreadcrumbItem} from "@/shared/ui/Breadcrumbs";

const getBreadcrumbFilters = (
    selectedFilters: SelectedFilter[],
): SelectedFilter[] => {
    const result: SelectedFilter[] = [];
    let insertsAdded = false;

    for (const filter of selectedFilters) {
        if (!BREADCRUMB_FILTER_KEYS.has(filter.key)) {
            continue;
        }

        if (filter.key === "inserts") {
            if (insertsAdded) {
                continue;
            }

            insertsAdded = true;
        }

        result.push(filter);
    }

    return result;
};

export const mapCatalogBreadcrumbs = (
    selectedFilters: SelectedFilter[] = [],
): BreadcrumbItem[] => {
    const filters = getBreadcrumbFilters(selectedFilters);

    let url = "";

    const items = filters.map((filter, index) => {
        const isLast = index === filters.length - 1;

        if (!isLast) {
            url += `/${filter.valueAlias}`;

            return {
                label: filter.value,
                href: `/catalog${url}`,
            };
        }

        return {
            label: filter.value,
        };
    });

    return [
        {
            label: "Каталог",
            href: "/catalog",
        },
        ...items,
    ];
};

